// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".project-info[data-v-1a99a42a]{display:flex;flex-direction:row;margin-bottom:8px}.project-info-label[data-v-1a99a42a]{width:100px;padding-right:12px;word-break:break-all}", ""]);
// Exports
module.exports = exports;
